/* globals $:false */

import ReportDetailP from './presenter/reportm.presenter.reportdetail.js';

var ReportDetail = function(core) {

    var _reportP,
        _$reportDetailsContainer = $("<section class='js-report-details report-details'></section>");

    var _reportName,
        _breadcrumbText = core.translateString("reportm", "item.title");


    return {
        init: function(reportName, entities) {
            var _entities = entities ? entities.split(",") : undefined;

            _reportP = new ReportDetailP(core, _$reportDetailsContainer);

            _reportP.init(reportName, _entities);

            _$reportDetailsContainer.appendTo('#'+core.getAppInstanceId());

            _reportName = reportName;
            _breadcrumbText = core.translateString("reportm", "item.title");
        },
        pause: function() {
            _reportP.pause();
            _$reportDetailsContainer.detach();
        },
        resume: function() {
            _reportP.resume();
            _$reportDetailsContainer.appendTo('#'+core.getAppInstanceId());
        },
        destroy: function() {
            _reportP.destroy();
            _$reportDetailsContainer.remove();
        },
        getDescription: function() {
            return _breadcrumbText + " \"" + _reportName + "\"";
        }
    };
};

export default ReportDetail;
